import React, { useState } from 'react';
import { SearchIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { BankLogo } from '../ui/BankLogo';
export interface Bank {
  id: string;
  name: string;
  logoUrl?: string;
}
export interface ProviderSelectionScreenProps {
  banks: Bank[];
  onSelectBank: (bank: Bank) => void;
}
export function ProviderSelectionScreen({
  banks,
  onSelectBank
}: ProviderSelectionScreenProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const filteredBanks = banks.filter(bank => bank.name.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-1184">
      <div data-id="element-1185">
        <h2 className="text-xl font-bold text-gray-900 mb-2 leading-tight" data-id="element-1186">
          Select the account provider you are giving us access to
        </h2>
        <p className="text-sm text-gray-600 leading-relaxed" data-id="element-1187">
          If we support your account provider, we will securely connect and
          authenticate this connection.
        </p>
      </div>

      <div className="relative" data-id="element-1188">
        <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-1189" />
        <input type="text" placeholder="Enter account provider..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-3.5 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#4DB8C4] focus:border-transparent transition-all text-sm placeholder:text-gray-400" data-id="element-1190" />
      </div>

      <div className="space-y-2.5" data-id="element-1191">
        {filteredBanks.map(bank => <button key={bank.id} onClick={() => onSelectBank(bank)} className="w-full flex items-center space-x-4 p-4 bg-white border-2 border-gray-200 rounded-xl hover:border-[#4DB8C4] hover:bg-[#4DB8C4]/5 hover:shadow-md transition-all duration-200 text-left active:scale-[0.98]" data-id="element-1192">
            <BankLogo bankName={bank.name} logoUrl={bank.logoUrl} data-id="element-1193" />
            <span className="font-semibold text-gray-900" data-id="element-1194">{bank.name}</span>
          </button>)}
      </div>
    </div>;
}